import React, { useState, useRef, useEffect } from "react";
import {
  Col,
  Table,
  Form,
  Row,
} from "react-bootstrap";

//components
import TableTemplate from "../../Components/TableTemplate/Table";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import ViewModal from "../../Components/Modals/ViewModal";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";

import toast from "react-hot-toast";
import {
  toastStyle,
  refreshPage,
  isAdmin,
} from "../../Helpers/Utils/Common";
import { useNavigate } from "react-router-dom";
import {
  getAllCategories,
} from "../../Helpers/apiCalls/Manage/Categories";
import { deleteCategory } from "../../Helpers/apiCalls/categoryApi";
import Footer from "../../Components/Footer/Footer";

export default function Category() {
  const [inactive, setInactive] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  let navigate = useNavigate();

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  // VIEW
  const [showViewBranchModal, setShowViewBranchModal] = useState(false);
  const handleShowViewBranchModal = () => setShowViewBranchModal(true);
  const handleCloseViewBranchModal = () => {
    setShowViewBranchModal(false);
  };

  const [tableData, setTableData] = useState([]);
  const [filterConfig, setFilterConfig] = useState({
    name: "",
    tab: "all",
    is_franchise: "",
  });
  const [selectedRow, setSelectedRow] = useState({});
  

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  };

  function renderViewTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th className="text-start">Name</th>
          </tr>
        </thead>
        <tbody>
          {selectedRow?.subcategories.map((categ) => {
            return (
              <tr>
                <td className="text-start">{categ.subname}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  async function del() {
    setIsClicked(true);
      const response = await deleteCategory(selectedRow.id);
      if (response.data) {
        toast.success(response.data.data.message, {
          style: toastStyle(),
        });
        setTimeout(() => refreshPage(), 1000);
      } else {
        response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
        })
        setTimeout(() => refreshPage(), 1000);
      }
  }

  async function fetchTableData() {
    setShowLoader(true);
    const response = await getAllCategories(filterConfig);
    if (response.data) {
      const res = response.data.data
      .sort((a, b) =>
          a.name > b.name
              ? 1
              : b.name > a.name
              ? -1
              : 0
      )
      .map((row) => {
        var info = row;
        info.action_btn = ActionBtn(row);
        return info;
      });
      setTableData(res);
    } else {
      setTableData([]);
    }
    setShowLoader(false);
  }

  //DROPDOWN
  function handleSelectChange(e, row, type) {
    setSelectedRow(row);
    if (e.target.value === "delete-branch") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-branch") {
      navigate("/category/edit/" + row.id);
    } else if (e.target.value === "view-branch") {
      handleShowViewBranchModal();
    } else {
      handleShowDeleteModal();
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row}
        onChange={(e) => handleSelectChange(e, row, type)}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-branch" className="color-options">
          View
        </option>
        {isAdmin && (
          <option value="edit-branch" className="color-options">
            Edit
          </option>
        )}
        {isAdmin && (
          <option value="delete-branch" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    );
  }

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        value={"view-branch"}
        onClick={(e) => handleSelectChange(e, row, row.type)}
      >
        View
      </button>
    );
  }

  useEffect(() => {
    fetchTableData();
  }, [filterConfig]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"MANAGE ITEM"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> Item Categories </h1>
          </Col>
          <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  name="name"
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
              placeholder="Search name..."
              />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
              <div className="PO-filters">
              <button
              className="add-btn"
              eventKey="braddex"
              onClick={() => navigate("/category/add")}
            >
              Add
            </button>
              </div>
          </Col>
        </Row>
        {/* TABLE */}

        <div className="tab-content">
          <TableTemplate
            tableHeaders={["-", "NAME", "", "", "", "ACTIONS"]}
            headerSelector={["-", "name", "", "", "", "action_btn"]}
            tableData={tableData}
            tableType="category"
            showLoader={showLoader}
            ViewBtn={(row) => ViewBtn(row)}
            withActionData={true}
          />
        </div>
      </div>
      {/* MODALS */}
      <DeleteModal
        text="branch"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={() => del()}
        isClicked={isClicked}
      />
      <ViewModal
        withButtons
        show={showViewBranchModal}
        onHide={handleCloseViewBranchModal}
        onEdit={() =>
          navigate("/category/edit/" + selectedRow.id)
        }
        size={"lg"}
      >
        <div className="mt-0">
          <div className="col-sm-12 m-0 space container-wrapper">
            <Row className="nc-modal-custom-row-view mt-0">
              <Col>
                CATEGORY NAME
                <Row className="nc-modal-custom-row ms-2">
                  <Col>{selectedRow?.name || "N/A"}</Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="col-sm-12 m-0 space">
            <Row className="nc-modal-custom-row">
              <Col>SUBCATEGORY</Col>
            </Row>
            <Row className="nc-modal-custom-row">
              <div className="edit-purchased-items">
                {!selectedRow?.subcategories || selectedRow?.subcategories.length === 0 ? (
                  <span>No Subcategory Found!</span>
                ) : (
                  renderViewTable()
                )}
              </div>
            </Row>
          </div>
        </div>
      </ViewModal>
      <Footer/>
    </div>
  );
}
